"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentEmbedUIEvents = exports.CONTENT_EMBED_UI_BASE_URL = exports.getContentEmbedUIOrigin = exports.ErrorTypes = exports.LoadingStatus = exports.urlPatterns = exports.ResponsiveElligibleEmbeds = exports.EXCLUSIVE_EMBED_URL_REGEX = exports.lazyLoadingRegex = exports.supportedScriptPatterns = exports.supportedMimeTypes = exports.selfClosingTags = exports.nodeTypes = exports.queryParamsDefaults = exports.ignoreTags = exports.EmbedReadMoreLink = exports.EmbedSizes = exports.EmbedFormats = exports.embedTypes = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var embedTypes = {
  AUDIO: 'audio',
  DIV: 'div',
  EMBED: 'embed',
  IFRAME: 'iframe',
  OBJECT: 'object',
  VIDEO: 'video'
};
exports.embedTypes = embedTypes;
var EmbedFormats = {
  URL: 'url',
  EMBED: 'embed'
};
exports.EmbedFormats = EmbedFormats;
var EmbedSizes = {
  CUSTOM: 'customWidth',
  FULL: 'fullWidth'
}; // TODO: Update the link to the KB article containing new information about using oEmbed

exports.EmbedSizes = EmbedSizes;
var EmbedReadMoreLink = 'https://knowledge.hubspot.com/articles/kcs_article/cos-pages-editor/how-can-i-add-a-video-on-my-hubspot-cos-page';
exports.EmbedReadMoreLink = EmbedReadMoreLink;
var ignoreTags = ['a', 'img'];
exports.ignoreTags = ignoreTags;
var queryParamsDefaults = {
  vimeo: {
    title: '0',
    byline: '0',
    portrait: '0',
    color: '8dc7dc'
  }
};
exports.queryParamsDefaults = queryParamsDefaults;
var nodeTypes = {
  ELEMENT: 1,
  TEXT: 3
};
exports.nodeTypes = nodeTypes;
var selfClosingTags = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
exports.selfClosingTags = selfClosingTags;
var supportedMimeTypes = {
  mp3: 'audio/mpeg',
  mp4: 'video/mp4',
  ogg: 'video/ogg',
  swf: 'application/x-shockwave-flash',
  wav: 'audio/wav',
  webm: 'video/webm'
};
exports.supportedMimeTypes = supportedMimeTypes;
var supportedScriptPatterns = {
  wistiaInlineResponsive: new RegExp(/<script src="(?:http(?:s)?:)?\/\/fast\.wistia\.com\/embed\/medias\/(.*?)\.jsonp" async[\s\S]*?><\/script>[\s]*?<script src="(?:http(?:s)?:)?\/\/fast\.wistia\.com\/assets\/external\/E-v1\.js" async[\s\S]*?><\/script>[\s]*?<div class="wistia_responsive_padding"[\s\S]*?">[\s]*?<div class="wistia_embed.*?>[\s\S]*?<\/div>[\s]*?<\/div>[\s]*?<\/div>/i),
  wistiaInlineFixed: new RegExp(/<script src="(?:http(?:s)?:)?\/\/fast.wistia.com\/embed\/medias\/(.*?).jsonp" async[\s\S]*?><\/script>[\s]*?<script src="(?:http(?:s)?:)?\/\/fast.wistia.com\/assets\/external\/E-v1.js" async[\s\S]*?><\/script>[\s]*?<div class="wistia_embed.*?" style="(.*?)">[\s\S]*?<\/div>[\s]*?/i),
  wistiaPopoverTextLink: new RegExp(/<script src="(?:http(?:s)?:)?\/\/fast.wistia.com\/embed\/medias\/(.*?).jsonp" async[\s\S]*?><\/script><script src="(?:http(?:s)?:)?\/\/fast.wistia.com\/assets\/external\/E-v1.js" async[s\S]*?><span class="wistia_embed [\s\S]*?popover=true[\s\S]*?<a href="#">([.\s\S]*?)<\/a><\/span>/i),
  wistiaPopoverThumbnail: new RegExp(/<script src="(?:http(?:s)?:)?\/\/fast.wistia.com\/embed\/medias\/(.*?).jsonp" async[\s\S]*?><\/script><script src="(?:http(?:s)?:)?\/\/fast.wistia.com\/assets\/external\/E-v1.js" async[s\S]*?>(?:<div class="wistia_responsive_padding"[\s\S]*?><div class="wistia_responsive_wrapper"[\s\S]*?>)?<span class="wistia_embed [\s\S]*?popover=true[\s\S]*?style="(.*?)">[\s\S]*?<\/span>(?:<\/div><\/div>)?/i),
  embedlySeo: new RegExp(/<blockquote.*?class="embedly-card".*><a\W+href="(.*)">(.*)<\/a>.*<p>(.*)<\/p><\/blockquote>\n*<script.*src="(?:http(?:s)?:)?\/\/cdn\.embedly\.com\/widgets\/platform.js".*><\/script>/i),
  embedlyPlain: new RegExp(/<a\W+hubspot-new-embed\W.*class="embedly-card".*href="(.+?)".*>(.*)<\/a>\n*\W*<script.*cdn.embedly.com.*<\/script>/i),
  scriptEmbed: new RegExp(/\{{\W*script_embed\((['"](.*)['"],\W*){0,}['"](.*)['"]\)\W*}}/i)
};
exports.supportedScriptPatterns = supportedScriptPatterns;
var lazyLoadingRegex = /<iframe(?:[^>]*( loading="([^ ]+)"){1}[^>]*)+>/;
exports.lazyLoadingRegex = lazyLoadingRegex;
var EXCLUSIVE_EMBED_URL_REGEX = /^(http(s?):)?\/\/(\S+)$/;
exports.EXCLUSIVE_EMBED_URL_REGEX = EXCLUSIVE_EMBED_URL_REGEX;
var ResponsiveElligibleEmbeds = ['dailymotion', 'giphy', 'google-maps', 'slideshare', 'twentythree', 'vimeo', 'wistia', 'youtube'];
exports.ResponsiveElligibleEmbeds = ResponsiveElligibleEmbeds;
var urlPatterns = [{
  regex: /youtu\.be\/([\w\-.]+)/i,
  type: 'iframe',
  w: 560,
  h: 315,
  url: '//www.youtube.com/embed/$1',
  allowFullscreen: true,
  service: 'youtube'
}, {
  regex: /youtube\.com(.+)v=([^&]+)/i,
  type: 'iframe',
  w: 560,
  h: 315,
  url: '//www.youtube.com/embed/$2',
  allowFullscreen: true,
  service: 'youtube'
}, {
  //   Add youtube playlist embed
  regex: /youtube.com\/embed\/videoseries?(.*)list=([^&]+)/i,
  type: 'iframe',
  w: 560,
  h: 315,
  url: '//www.youtube.com/embed/videoseries?list=$2',
  allowFullscreen: true,
  service: 'youtube'
}, {
  //   Add ?, &, ; and = characters for capturing query params (e.g ?rel=0)
  regex: /youtube.com\/embed\/([a-z0-9\-_?&;=]+)/i,
  type: 'iframe',
  w: 560,
  h: 315,
  url: '//www.youtube.com/embed/$1',
  allowFullscreen: true,
  service: 'youtube'
}, {
  regex: /vimeo\.com\/([0-9]+[a-z0-9\-_?&;=]*)/i,
  type: 'iframe',
  w: 640,
  h: 360,
  url: '//player.vimeo.com/video/$1',
  allowFullscreen: true,
  service: 'vimeo'
}, {
  regex: /vimeo\.com\/(.*)\/([0-9]+[a-z0-9\-_?&;=]*)/i,
  type: 'iframe',
  w: 640,
  h: 360,
  url: '//player.vimeo.com/video/$2',
  allowFullscreen: true,
  service: 'vimeo'
}, {
  regex: /instagram.com\/p\/([^/]+)/i,
  type: 'iframe',
  w: 425,
  h: 505,
  url: '//instagram.com/p/$1/embed/',
  allowFullscreen: '',
  service: 'instagram'
}, {
  regex: /wistia\.(com|net)\/medias\/([^/]+)/i,
  type: 'iframe',
  w: 620,
  h: 349,
  url: '//fast.wistia.net/embed/iframe/$2',
  service: 'wistia'
}, {
  regex: /maps\.google\.([a-z]{2,3})\/maps\/(.+)msid=(.+)/i,
  type: 'iframe',
  w: 425,
  h: 350,
  url: '//maps.google.com/maps/ms?msid=$2&output=embed"',
  allowFullscreen: '',
  service: 'google-maps'
}, {
  regex: /dai\.ly\/([\w\-.]+)/i,
  type: 'iframe',
  w: 480,
  h: 270,
  url: '//www.dailymotion.com/embed/video/$1',
  allowFullscreen: true,
  service: 'dailymotion'
}, {
  regex: /dailymotion\.com\/video\/([^_]+)/i,
  type: 'iframe',
  w: 480,
  h: 270,
  url: '//www.dailymotion.com/embed/video/$1',
  allowFullscreen: true,
  service: 'dailymotion'
}, {
  regex: /\/\/(\S+)\/((?:\d+|v)\.ihtml\/player\.html)([^/]+)/i,
  type: 'iframe',
  w: 560,
  h: 315,
  url: '//$1/$2$3',
  allowFullscreen: true,
  service: 'twentythree'
}, {
  regex: /giphy\.com\/(gifs|embed|media)\/([^/]+)/i,
  type: 'iframe',
  w: 480,
  h: 460,
  url: '//giphy.com/embed/$2',
  allowFullscreen: true,
  service: 'giphy'
}];
exports.urlPatterns = urlPatterns;
var LoadingStatus = {
  NONE: null,
  LOADING: 'loading',
  COMPLETE: 'complete'
};
exports.LoadingStatus = LoadingStatus;
var ErrorTypes = {
  NONE: null,
  FETCH: 'fetch',
  GENERAL: 'general'
}; // [content-embed-ui] is deployed at `preview.hubspoteditor(qa).com`

exports.ErrorTypes = ErrorTypes;

var getContentEmbedUIOrigin = function getContentEmbedUIOrigin() {
  var qa = _enviro.default.isProd() ? '' : 'qa';
  return "https://preview.hubspoteditor" + qa + ".com"; // Uncomment this if you want to run [content-embed-ui] locally since
  // benderproxy hosts all local apps on `local.hubspot(qa).com`. Be careful
  // when running [content-embed-ui] locally as the EmbedIframe has `sandbox`
  // of "allow-scripts allow-same-origin" which exposes possible XSS attacks.
  // return `https://local.hubspot${qa}.com`;
};

exports.getContentEmbedUIOrigin = getContentEmbedUIOrigin;
var CONTENT_EMBED_UI_BASE_URL = getContentEmbedUIOrigin() + "/content-embed-ui"; // These actions must match those in
// https://git.hubteam.com/HubSpot/content-embed-ui/static/js/utils/constants.js

exports.CONTENT_EMBED_UI_BASE_URL = CONTENT_EMBED_UI_BASE_URL;
var actionPrefix = 'ContentEmbedUI';
var ContentEmbedUIEvents = {
  READY: actionPrefix + ":Ready",
  SIZE_CHANGE: actionPrefix + ":SizeChange",
  SET_CONTENT: actionPrefix + ":SetContent",
  SET_CONTENT_DONE: actionPrefix + ":SetContentDone",
  DISCONNECT: actionPrefix + ":Disconnect"
};
exports.ContentEmbedUIEvents = ContentEmbedUIEvents;